import React from 'react'
import StockContainer from './StockContainer'

const Stock = () => <StockContainer data-test="component-stock-index" />
export default Stock
